import { FC } from 'react';
import { isFilled } from '@prismicio/client';
import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

interface SubheadlineProps {
  field?: RichTextField;
}

/**
 * Shared hero H2 (green sub-headline companion to {@link Headline}): same
 * Inter 500 / 40px / 55px / 120% typography as the H1, in brand green. A
 * `<strong>` keeps the medium weight and green color so an author's inline
 * bold doesn't shift the look. Renders nothing when the field is empty.
 */
const Subheadline: FC<SubheadlineProps> = ({ field }) => {
  if (!isFilled.richText(field)) {
    return null;
  }
  return (
    <PrismicRichText
      field={field}
      components={{
        heading2: ({ children }) => (
          <h2 className="m-0 font-inter !text-[40px] !font-medium !leading-[1.2] tracking-normal text-[#00f557] md:!text-[55px]">
            {children}
          </h2>
        ),
        strong: ({ children }) => (
          <strong className="!font-medium text-[#00f557]">{children}</strong>
        ),
      }}
    />
  );
};

export default Subheadline;
